




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { FilterSymbol, IPRCFilter } from "@/models";
import { namespace } from "vuex-class";
import RateChangesModule from "@/store/modules/rate-changes";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "DaysSame"
})
export default class DaysSame extends Vue {
  // ===== Store ===== //
  @rateChanges.Action private applyFilter!: (filter: IPRCFilter) => void;
  // ===== Props ===== //
  @Prop(Number) private readonly filter!: number;
  // ===== Data ===== //
  private selectedNumber = 0;
  private selectedSymbol: FilterSymbol | null = null;
  private symbols: FilterSymbol[] = [
    {
      filter: "[lt]",
      value: "less than"
    },
    {
      filter: "[lte]",
      value: "less than or equals"
    },
    {
      filter: "[eq]",
      value: "equal to"
    },
    {
      filter: "[gt]",
      value: "greater than"
    },
    {
      filter: "[gte]",
      value: "greater than or equals"
    }
  ]
  // ===== Methods ===== //
  @Watch("selectedDaysParameter")
  public handleSelectedDays(selectedDaysParameter: IPRCFilter): void {
    this.applyFilter(selectedDaysParameter);
  }
  // ===== Computed ===== //
  get operator(): string {
    return this.selectedSymbol ? this.selectedSymbol.filter : "";
  }
  get value(): string {
    return this.selectedSymbol ? this.selectedSymbol.value : "";
  }
  get selectedDaysParameter(): IPRCFilter {
    return {
      id: this.filter,
      chipText: `Days Same is ${this.value} ${this.selectedNumber}`,
      operator: this.operator,
      value: String(this.selectedNumber),
      query: `rent_days_unchanged${this.operator}=${this.selectedNumber}`
    };
  }
  // ===== Lifecycle Hooks ===== //
}
